import { Handle, Position } from '@xyflow/react';
import { getSyncNodeStyle } from '../lib/graphUtils';

const TYPE_LABELS = {
  tag: 'Tag',
  asset: 'Asset',
  insight: 'Hint',
  note: 'Note',
  raw: 'Raw',
  root: 'Think',
};

export default function SyncNode({ data, selected }) {
  const childCount = data.childCount || 0;
  const type = data.type || 'note';
  const weight = data.weight || 1;
  const label = TYPE_LABELS[type] || '';
  const titleSizeClass = type === 'tag' || type === 'root' ? 'text-[17px]' : 'text-[14px]';

  return (
    <div
      className="relative group h-full w-full select-none"
      style={getSyncNodeStyle(type, selected, weight, data.label, data.status)}
    >
      <Handle type="target" position={Position.Top} id="top-target" isConnectable={false} className="!h-2 !w-2 !border !border-slate-950 !bg-slate-400 !opacity-0" />
      <Handle type="source" position={Position.Top} id="top-source" isConnectable={false} className="!h-2 !w-2 !border !border-slate-950 !bg-slate-400 !opacity-0" />
      <Handle type="target" position={Position.Right} id="right-target" isConnectable={false} className="!h-2 !w-2 !border !border-slate-950 !bg-slate-400 !opacity-0" />
      <Handle type="source" position={Position.Right} id="right-source" isConnectable={false} className="!h-2 !w-2 !border !border-slate-950 !bg-slate-400 !opacity-0" />
      <Handle type="target" position={Position.Bottom} id="bottom-target" isConnectable={false} className="!h-2 !w-2 !border !border-slate-950 !bg-slate-400 !opacity-0" />
      <Handle type="source" position={Position.Bottom} id="bottom-source" isConnectable={false} className="!h-2 !w-2 !border !border-slate-950 !bg-slate-400 !opacity-0" />
      <Handle type="target" position={Position.Left} id="left-target" isConnectable={false} className="!h-2 !w-2 !border !border-slate-950 !bg-slate-400 !opacity-0" />
      <Handle type="source" position={Position.Left} id="left-source" isConnectable={false} className="!h-2 !w-2 !border !border-slate-950 !bg-slate-400 !opacity-0" />

      {type !== 'root' && (
        <div className="bg-white/5 px-2 py-0.5 border-b border-white/5 rounded-t-[10px] text-left">
          <span className="text-[10px] font-black uppercase tracking-widest opacity-60">{label}</span>
        </div>
      )}

      <div className="flex flex-1 items-center justify-center px-2 py-1 min-h-0 overflow-hidden relative">
        {data.status === 'pending' && (
          <span className="absolute top-1 left-1 bg-amber-500 text-slate-950 text-[8px] font-black px-1 rounded shadow-sm z-10">
            保留
          </span>
        )}
        <span className={`line-clamp-2 ${titleSizeClass} font-black leading-[1.2]`}>{data.label}</span>
        {data.parseFailed && (
          <span className="absolute top-1 right-1 text-red-500 font-black text-xs animate-pulse drop-shadow-[0_0_2px_rgba(0,0,0,0.8)]">
            ⚠
          </span>
        )}
      </div>

      {type !== 'root' && (
        <div className="flex items-center justify-center bg-white/10 px-2 py-1 border-t border-white/5 opacity-80 group-hover:opacity-100 transition-opacity rounded-b-[10px] gap-2">
          <div className="discuss-node flex items-center justify-center gap-1 text-[11px] font-black text-white/60 group-hover:text-white transition-colors cursor-pointer pointer-events-auto bg-white/5 hover:bg-white/10 px-2 py-0.5 rounded whitespace-nowrap">
            <span>議論</span>
            <svg className="h-3 w-3" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="4">
              <path d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
            </svg>
          </div>
          <div className="open-drill-down flex items-center justify-center gap-1 text-[11px] font-black text-white/60 group-hover:text-white transition-colors cursor-pointer pointer-events-auto bg-white/5 hover:bg-white/10 px-2 py-0.5 rounded whitespace-nowrap">
            <span>{type === 'tag' ? 'LIST' : 'OPEN'}</span>
            <svg className="h-3 w-3" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="4">
              <path d="M9 18l6-6-6-6" />
            </svg>
          </div>
        </div>
      )}

      {childCount > 0 && (
        <span className="absolute -right-3 -top-3 flex h-8 w-8 items-center justify-center rounded-full border-2 border-slate-950 bg-indigo-500 text-[18px] font-black text-white shadow-lg z-50">
          {childCount}
        </span>
      )}
    </div>
  );
}
